import { ContentReducerCreator } from '../types';

const exitEditingReducer = (create: ContentReducerCreator) => {
  return create.reducer((state) => {
    state.contentMarkedForDeletion = {};
  });
};

export default exitEditingReducer;
